export default __webpack_public_path__ + "static/media/img_top_4.7da28064.webp";